import React, { createRef, useEffect, useRef, useState } from "react";
import * as R from "ramda";
import { deleteServiceData } from "../../../actions/services-api";
import { ConnectionTypes, PensionProfessionalCategoryMapping } from "../../../constants/utils/connectionTypes";
import { useDispatch } from "react-redux";

export const Box = ({ service, alignLeft, setSelectedService }) => {
	const dispatch = useDispatch();
	const [elementOnFocus, setElementOnFocus] = useState(0);
	const [elRefs, setElRefs] = useState([]);
	const [contracts, setContracts] = useState([]);

	useEffect(() => {
		if (!R.isNil(service.contracts)) {
			let tmpContracts = [];
			if (service.contracts.length > 0) {
				service.contracts.forEach((c) => {
					let name = "";
					if (c.serviceId.toLowerCase().startsWith("custom")) {
						name = !R.isNil(c.customServiceDetails) ? c.customServiceDetails.name : "";
					} else if (service.connectionType === ConnectionTypes.otherActivity) {
						name = !R.isNil(c.payload) ? c.payload.name : "";
					} else if (service.connectionType === ConnectionTypes.activity) {
						name = !R.isNil(c.payload) ? c.payload.companyName : "";
					} else if (service.connectionType === ConnectionTypes.locataire) {
						name = !R.isNil(c.payload) ? c.payload.name : "";
					} else if (service.connectionType === ConnectionTypes.activity) {
						name = !R.isNil(c.payload) ? c.payload.companyName : "";
					} else if (service.connectionType === ConnectionTypes.etudiant) {
						name = !R.isNil(c.payload) ? c.payload.name : "";
					} else if (service.connectionType === ConnectionTypes.ehpad) {
						name = !R.isNil(c.payload) ? c.payload.name : "";
					} else if (service.connectionType === ConnectionTypes.pension) {
						if (R.isNil(c.payload)) {
							name = "";
						} else {
							let professionalName = "";
							PensionProfessionalCategoryMapping.forEach((cat) => {
								let matchingOption = cat.options.find((o) => o.value === c.payload.professionalCategory);
								if (!R.isNil(matchingOption)) {
									name = matchingOption.title;
								}
							});
						}
					} else {
						name = c.serviceName; //c.serviceId.split('|')[1];
					}

					let index = tmpContracts.findIndex((cont) => cont.name === name);
					if (index === -1) {
						tmpContracts.push({ name: name, ids: [c.id] });
					} else {
						tmpContracts[index].ids.push(c.id);
					}
				});
			}
			setContracts(tmpContracts);

			setElRefs((elRefs) =>
				Array(tmpContracts.length)
					.fill()
					.map((_, i) => elRefs[i] || createRef())
			);
		}
	}, [service.contracts, service.contracts.length]);

	return (
		<div className={"card card-body p-gd-2 border border-faded spider-card spider-card--" + (alignLeft ? "left" : "right")}>
			<div className="flex-row gx-1 aling-items-center justify-content-around">
				<div className={"col-auto" + (alignLeft ? " order-lg-first order-xl-last" : " mx-auto mb-2 mb-xl-unset")}>
					<div className="w-6 h-6 bg-white rounded d-flex align-items-center">
						<img className="img-fluid p-xs" src={service.icon} alt={service.title} />
					</div>
				</div>
				{/* <div className={"w-6 h-6 bg-white rounded d-flex align-items-center mx-auto" + (alignLeft ? ' order-lg-first order-xl-last' : ' mb-2 mb-xl-unset')}>
                    <img className="img-fluid p-xs" src={service.icon} alt={service.title} />
                </div> */}
				<div className={"col col-spider my-auto gx-1 text-xl-" + (alignLeft ? "right" : "left")}>
					<h5 className="h5 o-80 mb-auto text-uppercase font-weight-bold d-inline-block">
						<span className="order-first">{service.title}</span>
						<span className="mx-2 o-50">|</span>
						<span className="order-last">{!R.isNil(contracts) ? contracts.length : 0}</span>
					</h5>
					<div className={"flex-row align-items-center justify-content-xl-" + (alignLeft ? "end" : "start")}>
						{!R.isNil(contracts) && contracts.length > 1 && (alignLeft || (alignLeft === false && elementOnFocus > 0)) ? (
							<button
								className="btn btn-icon btn-faded btn-square o-50 o-100--hover mr-2 d-none d-xl-unset"
								onClick={() => {
									let elemenetToFocus = elementOnFocus;
									if (alignLeft === false && elementOnFocus > 0) {
										elemenetToFocus = elementOnFocus - 1;
									} else {
										if (elementOnFocus < service.contracts.length - 1) {
											elemenetToFocus = elementOnFocus + 1;
										}
									}
									if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
										elRefs[elemenetToFocus].current.scrollIntoView({ behavior: "smooth", block: alignLeft ? "end" : "start" });
									}
									setElementOnFocus(elemenetToFocus);
								}}>
								<i className="eva eva-arrow-ios-back-outline align-middle h4 lh-solid m-auto"></i>
							</button>
						) : (
							""
						)}
						<div className="scroller-nav mw-100">
							<div className={"nav justify-content-lg-center justify-content-xl-" + (alignLeft ? "end" : "start")}>
								{!R.isNil(contracts) && contracts.length > 0 ? (
									contracts.map((c, index) => {
										return (
											<span key={index} ref={elRefs[index]} className="btn btn-pill bg-faded">
												{c.name}
												{c.ids.length > 1 ? " #" + c.ids.length : ""}
												<i
													role="button"
													onClick={() => {
														c.ids.forEach((contract) => {
															dispatch(deleteServiceData(contract, service.connectionType));
														});
													}}
													className="icon-close eva eva-close-outline text-primary align-middle h4 lh-solid mb-0"></i>
											</span>
										);
									})
								) : (
									<div className="btn btn-pill bg-alert-warning py-1 px-xs">
										<i role="button" className="eva eva-alert-triangle-outline align-middle fs-lead lh-solid mb-0 mr-2 text-warning"></i>
										<span className="align-middle o-60">Aucune démarche configurée. </span>
									</div>
								)}
							</div>
						</div>
						{!R.isNil(contracts) && contracts.length > 1 ? (
							<button
								className={"btn btn-icon btn-faded btn-square o-50 o-100--hover ml-2" + (alignLeft && !(alignLeft && elementOnFocus > 0) ? " d-xl-none" : "")}
								onClick={() => {
									let elemenetToFocus = elementOnFocus;
									if (alignLeft && elementOnFocus > 0) {
										elemenetToFocus = elementOnFocus - 1;
									} else {
										if (elementOnFocus < service.contracts.length - 1) {
											elemenetToFocus = elemenetToFocus + 1;
										}
									}
									if (!R.isNil(elRefs[elemenetToFocus]) && !R.isNil(elRefs[elemenetToFocus].current)) {
										elRefs[elemenetToFocus].current.scrollIntoView({ behavior: "smooth", block: alignLeft ? "end" : "start" });
									}
									setElementOnFocus(elemenetToFocus);
								}}>
								<i className="eva eva-arrow-ios-forward-outline align-middle h4 lh-solid m-auto"></i>
							</button>
						) : (
							""
						)}
					</div>
				</div>
				<div className={"col-auto flex-column text-center" + (alignLeft ? " order-lg-last order-xl-first" : "")}>
					<button
						className="btn btn-icon p-1 o-50 o-100--hover mb-auto"
						data-toggle="modal"
						data-target="#servicesEdit"
						onClick={(e) => {
							e.preventDefault();
							setSelectedService(service.connectionType);
						}}>
						<i className="eva eva-edit-2-outline align-middle h4 lh-solid mb-auto mt-0 mx-auto"></i>
					</button>
					<button
						className="btn btn-icon p-1 o-50 o-100--hover mt-auto"
						data-toggle="modal"
						data-target="#deleteService"
						onClick={(e) => {
							e.preventDefault();
							setSelectedService(service);
						}}>
						<i className="eva eva-trash-2-outline align-middle h4 lh-solid mt-auto mb-0 mx-auto"></i>
					</button>
				</div>
			</div>
		</div>
	);
};
